



























import { defineComponent, computed } from '@vue/composition-api'

import { IUser } from '@/types/user'

type Props = {
  multiUsers: IUser[]
  total: number
  loading: boolean
}

export default defineComponent({
  name: 'UsersTable',
  props: {
    multiUsers: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store

    const headers = [
      { text: 'ID', value: 'id' },
      { text: 'コード', value: 'code' },
      { text: 'キャストCD', value: 'castId' },
      { text: 'キャスト名', value: 'castName' },
      { text: 'メール', value: 'mail' },
      { text: '権限', value: 'role' },
      { text: '報酬対象', value: 'isRewarded' },
      { text: '有効', value: 'isValid' },
    ]
    const items = computed(() => {
      return props.multiUsers
    })

    const onClickEditButton = async (
      item: Record<string, string | boolean>,
    ) => {
      await store.dispatch('multiUser/getMultiUser', item)
      context.root.$router.push('/user-edit').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }

    const options = {}

    return { headers, items, onClickEditButton, options }
  },
})
